import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import MuxPlayer from "@mux/mux-player-react"
import React from "react"
import MediaQuery from "react-responsive"
import styled from "styled-components"

const VideoWrapper = styled.div<{
  hideControls?: boolean
}>`
  width: 100%;
  height: 100%;

  > * {
    height: 100%;
    --controls: ${({ hideControls }) => hideControls && "none"};
    --media-object-fit: cover;
    --media-object-position: center;
    object-fit: cover;
    object-position: center;
  }
`

interface MuxVideoProps {
  autoplayVideo?: boolean
  hideControls?: boolean
  loopVideo?: boolean
  muxMobileVideo?: {
    thumbnailTime?: string
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
  muxVideo?: {
    thumbnailTime?: string
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
  onEnded?: () => void
  onPlaying?: (isMobile: boolean) => void
}

export default function MuxVideo({
  autoplayVideo = true,
  hideControls = false,
  loopVideo = true,
  muxMobileVideo,
  muxVideo,
  onEnded,
  onPlaying,
}: MuxVideoProps) {
  return (
    <MediaQuery query={breakpoints.mobileAndTabletOnly}>
      {(isMobile) => {
        const videoPlaybackId = isMobile
          ? muxMobileVideo?.video.playbackId || muxVideo?.video.playbackId
          : muxVideo?.video.playbackId
        const videoTitle = isMobile
          ? muxMobileVideo?.title || muxVideo?.title
          : muxVideo?.title
        const videoProps: any = {
          accentColor: colors.brandOrange,
          autoPlay: autoplayVideo ? "muted" : false,
          loop: loopVideo,
          nohotkeys: hideControls,
          onEnded: onEnded,
          onPlaying: onPlaying ? () => onPlaying(isMobile) : () => {},
          playbackId: videoPlaybackId,
          streamType: "on-demand",
          title: hideControls ? undefined : videoTitle,
        }

        let thumbnailTime

        if (isMobile && muxMobileVideo?.thumbnailTime) {
          thumbnailTime = muxMobileVideo.thumbnailTime
        } else if (muxVideo?.thumbnailTime) {
          thumbnailTime = muxVideo.thumbnailTime
        }

        if (thumbnailTime) {
          videoProps.thumbnailTime = parseInt(thumbnailTime)
        }

        return (
          <VideoWrapper hideControls={hideControls}>
            <MuxPlayer {...videoProps} />
          </VideoWrapper>
        )
      }}
    </MediaQuery>
  )
}
